<script context="module" lang="ts">
	import WYSIWYG from '../components/inputs/WYSIWYG.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';
	import Media from '$lib/components/media/Media.svelte';
	import Section from '$lib/components/layout/Section.svelte';
	import DirectusLink from '$lib/components/navigation/DirectusLink.svelte';
	import Button from '$lib/components/util/Button.svelte';
	import { page } from '$app/stores';
	import Card from '$lib/components/util/Card.svelte';
	import { getDirectus } from '$lib/util/directus';

	export async function load(data, params) {
		const jobs = await getDirectus(`items/jobs?fields=*.*`, null, params.lang);

		return {
			jobs: jobs.data
		};
	}

	export const config: SectionConfig = {
		collection: 'section_jobs',
		availableFor: ['pages', 'special-pages'],
		// load,
		query: gql`
			translations {
				languages_code {
					code
				}
				title
				subtitle
			}
	  `
	};

	// optional: define a type for the props (note: injectTranslations is applied)
	type Props = {
		title: string;
		subtitle: string;
	};
</script>

<!-- <script lang="ts">
	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)
	export let additionalData: any;

	let specialPageSlug: string;
	$: specialPageSlug = getCurrentPrefixSlug($page.params.lang);

	function getCurrentPrefixSlug(currentLang: string) {
		for (const specialPage of $page.data.specialPagesData) {
			if (specialPage.name === 'job') {
				for (const lang of specialPage.translations) {
					if (lang.languages_code === currentLang) {
						return lang.slug;
					}
				}
			}
		}
		return '';
	}
</script>

<Section>
	<div class="jobs-wrapper">
		<div class="header">
			<h2>{data.title}</h2>
			<p>{data.subtitle}</p>
		</div>
		<div class="jobs-grid">
			{#if additionalData.jobs}
				{#each additionalData.jobs as job}
					<Card
						title={job.title}
						tags={job.tags}
						text={job.summary}
						file={job.file}
						link={job.slug && specialPageSlug + '/' + job.slug}
					/>
				{/each}
			{/if}
		</div>
	</div>
</Section>

<style lang="scss">
	.header {
		margin-bottom: v(content-padding-lg);
		text-transform: uppercase;

		h2 {
			@include font(h2);
			color: color(blue__primary);
			max-width: max(500px, 45%);
		}

		p {
			@include font(h2);
			max-width: max(500px, 45%);
		}

		.subheadline {
			@include font(text-lg);
		}
	}
	.jobs-grid {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		grid-gap: v(content-padding);

		@include media(tablet) {
			grid-template-columns: repeat(3, minmax(0, 1fr));
		}

		@media (max-width: 800px) {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		@media (max-width: 480px) {
			grid-template-columns: repeat(1, minmax(0, 1fr));
		}
	}
</style> -->
